'use client';

import {
    Button,
    Card,
    CardBody,
    CardFooter,
    Typography,
} from '@material-tailwind/react';
import { Chip } from '@material-tailwind/react';
import Link from 'next/link';

export default function Rocket({ jsonData }) {
    return (
        <Card
            className="
                mt-10
                mx-4
                md:mx-auto
                w-full
                max-w-4xl
                rounded-3xl
                shadow-xl
                border border-gray-100
                bg-gradient-to-br from-white to-gray-50
            "
        >
            <CardBody
                className="
                    px-5 py-7
                    sm:px-6 sm:py-8
                    md:px-10 md:py-12
                "
            >
                {/* ICON */}
                <div className="flex items-center justify-center mb-4 md:mb-5">
                    <div className="p-3 rounded-2xl bg-blue-600/10">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className="h-8 w-8 text-blue-600"
                        >
                            <path
                                fillRule="evenodd"
                                d="M9.315 7.584C12.195 3.883 16.695 1.5 21.75 1.5a.75.75 0 01.75.75c0 5.056-2.383 9.555-6.084 12.436A6.75 6.75 0 019.75 22.5a.75.75 0 01-.75-.75v-4.131A15.838 15.838 0 016.382 15H2.25a.75.75 0 01-.75-.75 6.75 6.75 0 017.815-6.666zM15 6.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z"
                                clipRule="evenodd"
                            />
                            <path d="M5.26 17.242a.75.75 0 10-.897-1.203 5.243 5.243 0 00-2.05 5.022.75.75 0 00.625.627 5.243 5.243 0 005.022-2.051.75.75 0 10-1.202-.897 3.744 3.744 0 01-3.008 1.51c0-1.23.592-2.323 1.51-3.008z" />
                        </svg>
                    </div>
                </div>

                {/* TITLE */}
                <Typography
                    variant="h5"
                    color="blue-gray"
                    className="
                        text-center
                        font-extrabold
                        text-lg
                        md:text-xl
                        lg:text-2xl
                        leading-snug
                        md:leading-normal
                        mb-4 md:mb-5
                    "
                >
                    {jsonData.Typography1.content}
                </Typography>

                {/* CONTENT */}
                {jsonData.Typography2.content.ul ? (
                    <ul className="space-y-3 md:space-y-4 mt-4">
                        {Object.values(jsonData.Typography2.content.ul).map(
                            (item, index) => (
                                <li
                                    key={index}
                                    className="
                                    flex items-start gap-3
                                    text-gray-700
                                    text-sm md:text-base
                                    leading-relaxed
                                "
                                >
                                    <Chip
                                        value={index + 1}
                                        className="
                                        min-w-[28px]
                                        h-7
                                        flex items-center justify-center
                                        rounded-full
                                        bg-blue-600
                                        text-white
                                        font-semibold
                                        text-xs
                                        mt-0.5
                                    "
                                    />
                                    <span>{item}</span>
                                </li>
                            ),
                        )}
                    </ul>
                ) : (
                    <p className="text-center text-gray-600 text-sm md:text-base mt-4 leading-relaxed">
                        {jsonData.Typography2.content}
                    </p>
                )}
            </CardBody>

            {/* CTA */}
            <CardFooter className="pb-7 md:pb-8 flex justify-center">
                <Link
                    rel="canonical"
                    href="/contact-sales"
                    className="w-full sm:w-auto"
                >
                    <Button
                        size="md"
                        className="
                            w-full sm:w-auto
                            flex items-center justify-center gap-2
                            rounded-full
                            bg-blue-600
                            hover:bg-blue-800
                            shadow-md
                            hover:shadow-lg
                            transition-all
                            text-sm
                            px-6 py-3
                        "
                    >
                        {jsonData.Button}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="h-4 w-4"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                            />
                        </svg>
                    </Button>
                </Link>
            </CardFooter>
        </Card>
    );
}
